import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base/usecase';
import { HttpResponseEntity } from '../../domain/common.models';
import { OtpRequestData } from '../../domain/pin-otp-domain.models';
import { FSWalletPinTransactionRepository } from '../../repository/fs-wallet-pin-transaction.repository';

/**
 * Request Wallet PIN OTP Use Case - Clean Architecture Application Layer
 */
@Injectable({ providedIn: 'root' })
export class RequestWalletPinOtpUsecase implements UseCase<OtpRequestData, HttpResponseEntity> {
    constructor(private repository: FSWalletPinTransactionRepository) {}

    /**
     * Execute OTP request
     * @param data - Domain data for OTP request
     * @returns Observable of domain entity
     */
    execute(data: OtpRequestData): Observable<HttpResponseEntity> {
        return this.repository.RequestWalletPinOtp(data);
    }
}
